<template>
  <div>
    <div class="GeZai_Layer relative">
      <PanelImage @image_loaded="engravingElementsVisible = true;" @image_loading="engravingElementsVisible = false;" />

      <div class="body-img" :class="$store.getters.hOrV">
        <div class="table2" :class="{
          two: $store.state.artwork.format == 'double',
          vtwo: $store.state.artwork.format == 'vdouble',
          three: $store.state.artwork.format == 'triple',
          vthree: $store.state.artwork.format == 'vtriple',
        }">
          <engraving-elements :elements="layer4" :fontType="$store.state.artwork.fontType"
            v-show="engravingElementsVisible" />
          <engraving-elements :elements="rightLayer4" :fontType="$store.state.artwork.fontType"
            v-if="$store.state.artwork.format != 'single'" v-show="engravingElementsVisible" />
          <engraving-elements :elements="tripleRightLayer4" :fontType="$store.state.artwork.fontType"
            v-if="$store.getters.isTriple" v-show="engravingElementsVisible" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngravingElements from "../../../components/EngravingElements.vue";
var bjPositions = {
  default: {
    icon: {
      square: {
        small: {
          P7: { x: 4.5, y: 4.5 },
        },
        medium: {
          P7: { x: 4.5, y: 4.5 },
        },
      },
      rectangle: {
        small: {
          P1: { x: 3.89, y: 3.72 },
          P2: { x: 3.89, y: 4.5 },
          P3: { x: 3.89, y: 5.28 },
          P4: { x: 19.09, y: 3.72 },
          P5: { x: 19.09, y: 4.5 },
          P6: { x: 19.09, y: 5.28 },
          P7: { x: 11.5, y: 4.5 },
        },
        medium: {
          P2: { x: 4.85, y: 4.5 },
          P5: { x: 18.14, y: 4.5 },
          P7: { x: 11.5, y: 4.5 },
        },
      }
    },
    textL1: {
      small: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 3.69 },
        P3: { x: 0.55, y: 6.79 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 3.69 },
        P6: { x: 22.46, y: 6.79 },
        P7: { x: 11.5, y: 3.69 },
      },
      medium: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 3.2 },
        P3: { x: 0.55, y: 6.12 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 3.2 },
        P6: { x: 22.46, y: 6.12 },
        P7: { x: 11.5, y: 3.2 },
      },
      big: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 3.24 },
        P3: { x: 0.55, y: 5.45 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 3.24 },
        P6: { x: 22.46, y: 5.45 },
        P7: { x: 11.5, y: 3.24 },
      },
    },
    textL2: {
      small: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 2.63 },
        P3: { x: 0.55, y: 4.63 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 2.63 },
        P6: { x: 25.8, y: 4.63 },
        P7: { x: 11.5, y: 2.63 },
      },
      medium: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 2.04 },
        P3: { x: 0.55, y: 3.21 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 2.04 },
        P6: { x: 25.8, y: 3.21 },
        P7: { x: 11.5, y: 2.04 },
      },
      big: {
        P1: { x: 0.55, y: 0.68 },
        P2: { x: 0.55, y: 1.41 },
        P3: { x: 0.55, y: 1.88 },
        P4: { x: 22.46, y: 0.68 },
        P5: { x: 22.46, y: 1.41 },
        P6: { x: 25.8, y: 1.88 },
        P7: { x: 11.5, y: 1.41 },
      },
    },
  },
  metal: {
    icon: {
      square: {
        medium: {
          P7: { x: 4.5, y: 4.5 },
        },
      },
      rectangle: {
        medium: {
          P2: { x: 4.85, y: 4.5 },
          P5: { x: 18.4, y: 4.5 },
          P7: { x: 11.5, y: 4.5 },
        },
      }

    },
    textL1: {
      medium: {
        P1: { x: 0.55, y: 0.55 },
        P2: { x: 0.55, y: 3.2 },
        P3: { x: 0.55, y: 5.58 },
        P4: { x: 22.45, y: 0.55 },
        P5: { x: 22.45, y: 3.2 },
        P6: { x: 22.45, y: 5.58 },
        P7: { x: 11.5, y: 3.2 },
      },
    },
    textL2: {
      medium: {
        P1: { x: 0.55, y: 0.55 },
        P2: { x: 0.55, y: 1.4 },
        P3: { x: 0.55, y: 2.05 },
        P4: { x: 22.45, y: 0.55 },
        P5: { x: 22.45, y: 1.4 },
        P6: { x: 22.45, y: 2.05 },
        P7: { x: 11.5, y: 1.4 },
      },
    },
  },
  button: {
    square: {
      single: {
        A: {
          left: [
            { x: 24.4, y: 43 },
          ],
          right: [
            { x: 61.6, y: 43 },
          ]
        },
        B: {
          left: [
            { x: 24.4, y: 26.2 },
            { x: 24.4, y: 59.8 },
          ],
          right: [
            { x: 61.6, y: 26.2 },
            { x: 61.6, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 24.4, y: 17.8 },
            { x: 24.4, y: 43 },
            { x: 24.4, y: 68.2 },
          ],
          right: [
            { x: 61.6, y: 17.8 },
            { x: 61.6, y: 43 },
            { x: 61.6, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 24.4, y: 17.8 },
            { x: 24.4, y: 34.6 },
            { x: 24.4, y: 51.4 },
            { x: 24.4, y: 68.2 }
          ],
          right: [
            { x: 61.6, y: 17.8 },
            { x: 61.6, y: 34.6 },
            { x: 61.6, y: 51.4 },
            { x: 61.6, y: 68.2 }
          ]
        },
        M1: {
          left: [
            { x: 24.4, y: 51.4 },
            { x: 16.1, y: 68.2 },
            { x: 32.5, y: 68.2 },
            { x: 61.6, y: 51.4 },
            { x: 53.3, y: 68.2 },
            { x: 69.7, y: 68.2 },
          ]
        }
      },
      double: {
        A: {
          left: [
            { x: 25.6, y: 43 },

          ],
          right: [
            { x: 62.86, y: 43 },
          ]
        },
        B: {
          left: [
            { x: 25.6, y: 26.2 },
            { x: 25.6, y: 59.8 },
          ],
          right: [
            { x: 62.86, y: 26.2 },
            { x: 62.86, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 25.6, y: 17.8 },
            { x: 25.6, y: 43 },
            { x: 25.6, y: 68.2 },
          ],
          right: [
            { x: 62.86, y: 17.8 },
            { x: 62.86, y: 43 },
            { x: 62.86, y: 68.2 }
          ]
        },
        D: {
          left: [
            { x: 25.6, y: 17.8 },
            { x: 25.6, y: 34.6 },
            { x: 25.6, y: 51.4 },
            { x: 25.6, y: 68.2 },
          ],
          right: [
            { x: 62.86, y: 17.8 },
            { x: 62.86, y: 34.6 },
            { x: 62.86, y: 51.4 },
            { x: 62.86, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 25.6, y: 51.4 },
            { x: 17.42, y: 68.2 },
            { x: 33.75, y: 68.2 },
            { x: 62.86, y: 51.4 },
            { x: 54.55, y: 68.2 },
            { x: 70.95, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        }
      },
      vdouble: {
        A: {
          left: [
            { x: 24.4, y: 44.23 },
          ],
          right: [
            { x: 61.6, y: 44.23 },
          ]
        },
        B: {
          left: [
            { x: 24.4, y: 27.43 },
            { x: 24.4, y: 61.03 },
          ],
          right: [
            { x: 61.1, y: 27.43 },
            { x: 61.1, y: 61.03 },
          ]
        },
        C: {
          left: [
            { x: 24.4, y: 19.03 },
            { x: 24.4, y: 44.23 },
            { x: 24.4, y: 69.43 },
          ],
          right: [
            { x: 61.1, y: 19.03 },
            { x: 61.1, y: 44.23 },
            { x: 61.1, y: 69.43 },
          ]
        },
        D: {
          left: [
            { x: 24.4, y: 19.03 },
            { x: 24.4, y: 35.83 },
            { x: 24.4, y: 52.63 },
            { x: 24.4, y: 69.43 },
          ],
          right: [
            { x: 61.1, y: 19.03 },
            { x: 61.1, y: 35.83 },
            { x: 61.1, y: 52.63 },
            { x: 61.1, y: 69.43 },
          ]
        },
        M1: {
          left: [
            { x: 24.4, y: 52.63 },
            { x: 16.1, y: 69.43 },
            { x: 32.55, y: 69.43 },
            { x: 61.1, y: 52.63 },
            { x: 53.3, y: 69.43 },
            { x: 69.7, y: 69.43 },
          ]
        },
        SK: {
          left: []
        },
      },
      triple: {
        A: {
          left: [
            { x: 26.85, y: 43 },

          ],
          right: [
            { x: 64.11, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 26.85, y: 26.2 },
            { x: 26.85, y: 59.8 },
          ],
          right: [
            { x: 64.11, y: 26.2 },
            { x: 64.11, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 26.85, y: 17.8 },
            { x: 26.85, y: 43 },
            { x: 26.85, y: 68.2 },
          ],
          right: [
            { x: 64.11, y: 17.8 },
            { x: 64.11, y: 43 },
            { x: 64.11, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 26.85, y: 17.8 },
            { x: 26.85, y: 34.6 },
            { x: 26.85, y: 51.4 },
            { x: 26.85, y: 68.2 },
          ],
          right: [
            { x: 64.11, y: 17.8 },
            { x: 64.11, y: 34.6 },
            { x: 64.11, y: 51.4 },
            { x: 64.11, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 26.85, y: 51.4 },
            { x: 18.66, y: 68.2 },
            { x: 35.07, y: 68.2 },
            { x: 64.11, y: 51.4 },
            { x: 55.87, y: 68.2 },
            { x: 72.27, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        },
      },
      vtriple: {
        A: {
          left: [
            { x: 24.4, y: 45.48 },

          ],
          right: [
            { x: 61.6, y: 45.48 },
          ],
        },
        B: {
          left: [
            { x: 24.4, y: 28.68 },
            { x: 24.4, y: 62.27 },
          ],
          right: [
            { x: 61.1, y: 28.68 },
            { x: 61.1, y: 62.27 },
          ]
        },
        C: {
          left: [
            { x: 24.4, y: 20.28 },
            { x: 24.4, y: 45.48 },
            { x: 24.4, y: 70.68 },
          ],
          right: [
            { x: 61.1, y: 20.28 },
            { x: 61.1, y: 45.48 },
            { x: 61.1, y: 70.68 },
          ]
        },
        D: {
          left: [
            { x: 24.4, y: 20.28 },
            { x: 24.4, y: 37.08 },
            { x: 24.4, y: 53.88 },
            { x: 24.4, y: 70.68 },
          ],
          right: [
            { x: 61.1, y: 20.28 },
            { x: 61.1, y: 37.08 },
            { x: 61.1, y: 53.88 },
            { x: 61.1, y: 70.68 },
          ]
        },
        M1: {
          left: [
            { x: 24.4, y: 53.87 },
            { x: 16.1, y: 70.68 },
            { x: 32.5, y: 70.68 },
            { x: 61.6, y: 53.87 },
            { x: 53.3, y: 70.68 },
            { x: 69.7, y: 70.68 },
          ],
        },
        SK: {
          left: [],
        },
      }
    },
    rectangle: {
      single: {
        A: {
          left: [
            { x: 17.32, y: 43 },
          ],
          right: [
            { x: 54.6, y: 43 },
          ]
        },
        B: {
          left: [
            { x: 17.32, y: 26.2 },
            { x: 17.32, y: 59.8 },
          ],
          right: [
            { x: 54.6, y: 26.2 },
            { x: 54.6, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 17.32, y: 17.8 },
            { x: 17.32, y: 43 },
            { x: 17.32, y: 68.2 },
          ],
          right: [
            { x: 54.6, y: 17.8 },
            { x: 54.6, y: 43 },
            { x: 54.6, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 17.32, y: 17.8 },
            { x: 17.32, y: 34.6 },
            { x: 17.32, y: 51.4 },
            { x: 17.32, y: 68.2 }
          ],
          right: [
            { x: 54.6, y: 17.8 },
            { x: 54.6, y: 34.6 },
            { x: 54.6, y: 51.4 },
            { x: 54.6, y: 68.2 }
          ]
        },
        M1: {
          left: [
            { x: 17.32, y: 51.4 },
            { x: 17.32, y: 68.2 },
            { x: 54.6, y: 51.4 },
            { x: 54.6, y: 68.2 },
          ]
        }
      },
      double: {
        A: {
          left: [
            { x: 18.62, y: 43 },

          ],
          right: [
            { x: 55.88, y: 43 },
          ]
        },
        B: {
          left: [
            { x: 18.62, y: 26.2 },
            { x: 18.62, y: 59.8 },
          ],
          right: [
            { x: 55.88, y: 26.2 },
            { x: 55.88, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 18.62, y: 17.8 },
            { x: 18.62, y: 43 },
            { x: 18.62, y: 68.2 },
          ],
          right: [
            { x: 55.88, y: 17.8 },
            { x: 55.88, y: 43 },
            { x: 55.88, y: 68.2 }
          ]
        },
        D: {
          left: [
            { x: 18.62, y: 17.8 },
            { x: 18.62, y: 34.6 },
            { x: 18.62, y: 51.4 },
            { x: 18.62, y: 68.2 },
          ],
          right: [
            { x: 55.88, y: 17.8 },
            { x: 55.88, y: 34.6 },
            { x: 55.88, y: 51.4 },
            { x: 55.88, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 18.62, y: 51.4 },
            { x: 18.62, y: 68.2 },
            { x: 55.88, y: 51.4 },
            { x: 55.88, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        }
      },
      vdouble: {
        A: {
          left: [
            { x: 17.36, y: 44.23 },
          ],
          right: [
            { x: 54.63, y: 44.23 },
          ]
        },
        B: {
          left: [
            { x: 17.36, y: 27.43 },
            { x: 17.36, y: 61.03 },
          ],
          right: [
            { x: 54.63, y: 27.43 },
            { x: 54.63, y: 61.03 },
          ]
        },
        C: {
          left: [
            { x: 17.36, y: 19.03 },
            { x: 17.36, y: 44.23 },
            { x: 17.36, y: 69.43 },
          ],
          right: [
            { x: 54.63, y: 19.03 },
            { x: 54.63, y: 44.23 },
            { x: 54.63, y: 69.43 },
          ]
        },
        D: {
          left: [
            { x: 17.36, y: 19.03 },
            { x: 17.36, y: 35.83 },
            { x: 17.36, y: 52.63 },
            { x: 17.36, y: 69.43 },
          ],
          right: [
            { x: 54.63, y: 19.03 },
            { x: 54.63, y: 35.83 },
            { x: 54.63, y: 52.63 },
            { x: 54.63, y: 69.43 },
          ]
        },
        M1: {
          left: [
            { x: 17.36, y: 52.63 },
            { x: 17.36, y: 69.43 },
            { x: 54.63, y: 52.63 },
            { x: 54.63, y: 69.43 },
          ]
        },
        SK: {
          left: []
        },
      },
      triple: {
        A: {
          left: [
            { x: 19.87, y: 43 },

          ],
          right: [
            { x: 57.13, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 19.87, y: 26.2 },
            { x: 19.87, y: 59.8 },
          ],
          right: [
            { x: 57.13, y: 26.2 },
            { x: 57.13, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 19.87, y: 17.8 },
            { x: 19.87, y: 43 },
            { x: 19.87, y: 68.2 },
          ],
          right: [
            { x: 57.13, y: 17.8 },
            { x: 57.13, y: 43 },
            { x: 57.13, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 19.87, y: 17.8 },
            { x: 19.87, y: 34.6 },
            { x: 19.87, y: 51.4 },
            { x: 19.87, y: 68.2 },
          ],
          right: [
            { x: 57.13, y: 17.8 },
            { x: 57.13, y: 34.6 },
            { x: 57.13, y: 51.4 },
            { x: 57.13, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 19.87, y: 51.4 },
            { x: 19.87, y: 68.2 },
            { x: 57.13, y: 51.4 },
            { x: 57.13, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        },
      },
      vtriple: {
        A: {
          left: [
            { x: 17.36, y: 45.48 },

          ],
          right: [
            { x: 54.63, y: 45.48 },
          ],
        },
        B: {
          left: [
            { x: 17.36, y: 28.68 },
            { x: 17.36, y: 62.27 },
          ],
          right: [
            { x: 54.63, y: 28.68 },
            { x: 54.63, y: 62.27 },
          ]
        },
        C: {
          left: [
            { x: 17.36, y: 20.28 },
            { x: 17.36, y: 45.48 },
            { x: 17.36, y: 70.68 },
          ],
          right: [
            { x: 54.63, y: 20.28 },
            { x: 54.63, y: 45.48 },
            { x: 54.63, y: 70.68 },
          ]
        },
        D: {
          left: [
            { x: 17.36, y: 20.28 },
            { x: 17.36, y: 37.08 },
            { x: 17.36, y: 53.88 },
            { x: 17.36, y: 70.68 },
          ],
          right: [
            { x: 54.63, y: 20.28 },
            { x: 54.63, y: 37.08 },
            { x: 54.63, y: 53.88 },
            { x: 54.63, y: 70.68 },
          ]
        },
        M1: {
          left: [
            { x: 17.36, y: 53.87 },
            { x: 17.36, y: 70.68 },
            { x: 54.63, y: 53.87 },
            { x: 54.63, y: 70.68 },
          ],
        },
        SK: {
          left: [],
        },
      }
    }
  },
  rightButton: {
    square: {
      double: {
        A: {
          left: [
            { x: 123.1, y: 43 },

          ],
          right: [
            { x: 160.36, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 123.1, y: 26.2 },
            { x: 123.1, y: 59.8 },
          ],
          right: [
            { x: 160.36, y: 26.2 },
            { x: 160.36, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 123.1, y: 17.8 },
            { x: 123.1, y: 43 },
            { x: 123.1, y: 68.2 },
          ],
          right: [
            { x: 160.36, y: 17.8 },
            { x: 160.36, y: 43 },
            { x: 160.36, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 123.1, y: 17.8 },
            { x: 123.1, y: 34.6 },
            { x: 123.1, y: 51.4 },
            { x: 123.1, y: 68.2 },
          ],
          right: [
            { x: 160.36, y: 17.8 },
            { x: 160.36, y: 34.6 },
            { x: 160.36, y: 51.4 },
            { x: 160.36, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 123.1, y: 51.4 },
            { x: 114.92, y: 68.2 },
            { x: 131.33, y: 68.2 },
            { x: 160.36, y: 51.4 },
            { x: 152.13, y: 68.2 },
            { x: 168.53, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        },
      },
      vdouble: {
        A: {
          left: [
            { x: 24.4, y: 141.73 },
          ],
          right: [
            { x: 61.6, y: 141.73 },
          ]
        },
        B: {
          left: [
            { x: 24.4, y: 124.93 },
            { x: 24.4, y: 158.53 },
          ],
          right: [
            { x: 61.1, y: 124.93 },
            { x: 61.1, y: 158.53 },
          ]
        },
        C: {
          left: [
            { x: 24.4, y: 116.53 },
            { x: 24.4, y: 141.73 },
            { x: 24.4, y: 166.93 },
          ],
          right: [
            { x: 61.1, y: 116.53 },
            { x: 61.1, y: 141.73 },
            { x: 61.1, y: 166.93 },
          ]
        },
        D: {
          left: [
            { x: 24.4, y: 116.53 },
            { x: 24.4, y: 133.33 },
            { x: 24.4, y: 150.13 },
            { x: 24.4, y: 166.93 },
          ],
          right: [
            { x: 61.1, y: 116.53 },
            { x: 61.1, y: 133.33 },
            { x: 61.1, y: 150.13 },
            { x: 61.1, y: 166.93 },
          ]
        },
        M1: {
          left: [
            { x: 24.4, y: 150.13 },
            { x: 16.1, y: 166.93 },
            { x: 32.5, y: 166.93 },
            { x: 61.6, y: 150.13 },
            { x: 53.3, y: 166.93 },
            { x: 69.7, y: 166.93 },
          ],
        },
        SK: {
          left: [],
        },
      },
      triple: { SK: { left: [] } },
      vtriple: { SK: { left: [] } },
    },
    rectangle: {
      double: {
        A: {
          left: [
            { x: 116.12, y: 43 },

          ],
          right: [
            { x: 153.38, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 116.12, y: 26.2 },
            { x: 116.12, y: 59.8 },
          ],
          right: [
            { x: 153.38, y: 26.2 },
            { x: 153.38, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 116.12, y: 17.8 },
            { x: 116.12, y: 43 },
            { x: 116.12, y: 68.2 },
          ],
          right: [
            { x: 153.38, y: 17.8 },
            { x: 153.38, y: 43 },
            { x: 153.38, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 116.12, y: 17.8 },
            { x: 116.12, y: 34.6 },
            { x: 116.12, y: 51.4 },
            { x: 116.12, y: 68.2 },
          ],
          right: [
            { x: 153.38, y: 17.8 },
            { x: 153.38, y: 34.6 },
            { x: 153.38, y: 51.4 },
            { x: 153.38, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 116.12, y: 51.4 },
            { x: 116.12, y: 68.2 },
            { x: 153.38, y: 51.4 },
            { x: 153.38, y: 68.2 },
          ],
        },
        SK: {
          left: [],
        },
      },
      vdouble: {
        A: {
          left: [
            { x: 17.36, y: 141.73 },
          ],
          right: [
            { x: 54.63, y: 141.73 },
          ]
        },
        B: {
          left: [
            { x: 17.36, y: 124.93 },
            { x: 17.36, y: 158.53 },
          ],
          right: [
            { x: 54.63, y: 124.93 },
            { x: 54.63, y: 158.53 },
          ]
        },
        C: {
          left: [
            { x: 17.36, y: 116.53 },
            { x: 17.36, y: 141.73 },
            { x: 17.36, y: 166.93 },
          ],
          right: [
            { x: 54.63, y: 116.53 },
            { x: 54.63, y: 141.73 },
            { x: 54.63, y: 166.93 },
          ]
        },
        D: {
          left: [
            { x: 17.36, y: 116.53 },
            { x: 17.36, y: 133.33 },
            { x: 17.36, y: 150.13 },
            { x: 17.36, y: 166.93 },
          ],
          right: [
            { x: 54.63, y: 116.53 },
            { x: 54.63, y: 133.33 },
            { x: 54.63, y: 150.13 },
            { x: 54.63, y: 166.93 },
          ]
        },
        M1: {
          left: [
            { x: 17.36, y: 150.13 },
            { x: 17.36, y: 166.93 },
            { x: 54.63, y: 150.13 },
            { x: 54.63, y: 166.93 },
          ],
        },
        SK: {
          left: [],
        },
      },
      triple: { SK: { left: [] } },
      vtriple: { SK: { left: [] } },
    }
  },
  tripleRightButton: {
    square: {
      triple: {
        A: {
          left: [
            { x: 221.85, y: 43 },

          ],
          right: [
            { x: 259.11, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 221.85, y: 26.2 },
            { x: 221.85, y: 59.8 },
          ],
          right: [
            { x: 259.11, y: 26.2 },
            { x: 259.11, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 221.85, y: 17.8 },
            { x: 221.85, y: 43 },
            { x: 221.85, y: 68.2 },
          ],
          right: [
            { x: 259.11, y: 17.8 },
            { x: 259.11, y: 43 },
            { x: 259.11, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 221.85, y: 17.8 },
            { x: 221.85, y: 34.6 },
            { x: 221.85, y: 51.4 },
            { x: 221.85, y: 68.2 },
          ],
          right: [
            { x: 259.11, y: 17.8 },
            { x: 259.11, y: 34.6 },
            { x: 259.11, y: 51.4 },
            { x: 259.11, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 221.85, y: 51.4 },
            { x: 213.67, y: 68.2 },
            { x: 230.08, y: 68.2 },
            { x: 259.11, y: 51.4 },
            { x: 250.88, y: 68.2 },
            { x: 267.28, y: 68.2 },
          ],
        },
        SK: { left: [] },
      },
      vtriple: {
        A: {
          left: [
            { x: 24.4, y: 240.48 },
          ],
          right: [
            { x: 61.6, y: 240.48 },
          ]
        },
        B: {
          left: [
            { x: 24.4, y: 223.68 },
            { x: 24.4, y: 257.28 },
          ],
          right: [
            { x: 61.1, y: 223.68 },
            { x: 61.1, y: 257.28 },
          ]
        },
        C: {
          left: [
            { x: 24.4, y: 215.28 },
            { x: 24.4, y: 240.48 },
            { x: 24.4, y: 265.68 },
          ],
          right: [
            { x: 61.1, y: 215.28 },
            { x: 61.1, y: 240.48 },
            { x: 61.1, y: 265.68 },
          ]
        },
        D: {
          left: [
            { x: 24.4, y: 215.28 },
            { x: 24.4, y: 232.09 },
            { x: 24.4, y: 248.89 },
            { x: 24.4, y: 265.68 },
          ],
          right: [
            { x: 61.1, y: 215.28 },
            { x: 61.1, y: 232.09 },
            { x: 61.1, y: 248.89 },
            { x: 61.1, y: 265.68 },
          ]
        },
        M1: {
          left: [
            { x: 24.4, y: 248.87 },
            { x: 16.1, y: 265.68 },
            { x: 32.5, y: 265.68 },
            { x: 61.6, y: 248.87 },
            { x: 53.3, y: 265.68 },
            { x: 69.7, y: 265.68 },
          ],
        },
        SK: {
          left: [],
        }
      }
    },
    rectangle: {
      triple: {
        A: {
          left: [
            { x: 214.87, y: 43 },

          ],
          right: [
            { x: 252.13, y: 43 },
          ],
        },
        B: {
          left: [
            { x: 214.87, y: 26.2 },
            { x: 214.87, y: 59.8 },
          ],
          right: [
            { x: 252.13, y: 26.2 },
            { x: 252.13, y: 59.8 },
          ]
        },
        C: {
          left: [
            { x: 214.87, y: 17.8 },
            { x: 214.87, y: 43 },
            { x: 214.87, y: 68.2 },
          ],
          right: [
            { x: 252.13, y: 17.8 },
            { x: 252.13, y: 43 },
            { x: 252.13, y: 68.2 },
          ]
        },
        D: {
          left: [
            { x: 214.87, y: 17.8 },
            { x: 214.87, y: 34.6 },
            { x: 214.87, y: 51.4 },
            { x: 214.87, y: 68.2 },
          ],
          right: [
            { x: 252.13, y: 17.8 },
            { x: 252.13, y: 34.6 },
            { x: 252.13, y: 51.4 },
            { x: 252.13, y: 68.2 },
          ]
        },
        M1: {
          left: [
            { x: 214.87, y: 51.4 },
            { x: 214.87, y: 68.2 },
            { x: 252.13, y: 51.4 },
            { x: 252.13, y: 68.2 },
          ],
        },
        SK: { left: [] },
      },
      vtriple: {
        A: {
          left: [
            { x: 17.36, y: 240.48 },
          ],
          right: [
            { x: 54.63, y: 240.48 },
          ]
        },
        B: {
          left: [
            { x: 17.36, y: 223.68 },
            { x: 17.36, y: 257.28 },
          ],
          right: [
            { x: 54.63, y: 223.68 },
            { x: 54.63, y: 257.28 },
          ]
        },
        C: {
          left: [
            { x: 17.36, y: 215.28 },
            { x: 17.36, y: 240.48 },
            { x: 17.36, y: 265.68 },
          ],
          right: [
            { x: 54.63, y: 215.28 },
            { x: 54.63, y: 240.48 },
            { x: 54.63, y: 265.68 },
          ]
        },
        D: {
          left: [
            { x: 17.36, y: 215.28 },
            { x: 17.36, y: 232.09 },
            { x: 17.36, y: 248.89 },
            { x: 17.36, y: 265.68 },
          ],
          right: [
            { x: 54.63, y: 215.28 },
            { x: 54.63, y: 232.09 },
            { x: 54.63, y: 248.89 },
            { x: 54.63, y: 265.68 },
          ]
        },
        M1: {
          left: [
            { x: 17.36, y: 248.87 },
            { x: 17.36, y: 265.68 },
            { x: 54.63, y: 248.87 },
            { x: 54.63, y: 265.68 },
          ],
        },
        SK: {
          left: [],
        }
      }
    }
  },
  buttonSize: {
    round: { height: 9, width: 9 },
    square: { height: 9, width: 9 },
    rectangle: { height: 9, width: 23 },
    oval: { height: 9, width: 23 },
  },
  L2offset: {
    default: {
      small: 2.19,
      medium: 2.93,
    },
    metal: {
      medium: 3.53,
    },
  },
  alignment: {
    iconOnly: {
      topleft: { textL1: "", icon: "P2" },
      topcenter: { textL1: "", icon: "P7" },
      topright: { textL1: "", icon: "P5" },
      bottomleft: { textL1: "", icon: "P2" },
      bottomcenter: { textL1: "", icon: "P7" },
      bottomright: { textL1: "", icon: "P5" },
    },
    singleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconSingleLineText: {
      topleft: { textL1: "P1", icon: "P5" },
      topright: { textL1: "P4", icon: "P2" },
      bottomleft: { textL1: "P3", icon: "P5" },
      bottomright: { textL1: "P6", icon: "P2" },
    },
    doubleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconDoubleLineText: {
      topleft: { textL1: "P1", icon: "P5" },
      topright: { textL1: "P4", icon: "P2" },
      bottomleft: { textL1: "P3", icon: "P5" },
      bottomright: { textL1: "P6", icon: "P2" },
    },
  },
};

import isBigIconMixin from "../../../mixins/isBigIconMixin";
import PanelImage from "./PanelImage.vue";

export default {
  name: "BlackJackPanel",
  components: {
    EngravingElements,
    PanelImage
  },
  mixins: [isBigIconMixin],
  data() {
    return {
      engravingElementsVisible: false,
      textSizeLabel: null,
      fontSize: null
    };
  },
  created() {
    this.styleMap = this.$store.state.styleMap;
  },
  methods: {
    getAlignment(i, alignment = "alignment") {
      if (!this.isBigIcon(i.content)) {
        return this.$store.state.artwork[alignment];
      }
      return this.$store.state.artwork[alignment]
        .replace("left", "center")
        .replace("right", "center");
    },
  },
  computed: {
    layer4: function () {
      var textSizeLabel = this.$store.state.textSizeMap[this.$store.state.artwork.fontSize];
      var alignment = {};
      if (
        typeof bjPositions.alignment[this.$store.state.artwork.layoutStyle] !=
        "undefined"
      ) {
        alignment =
          bjPositions.alignment[this.$store.state.artwork.layoutStyle][
          this.$store.state.artwork.alignment
          ];
      }
      var layoutList = [];
      let right = [];

      let left = bjPositions.button[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.leftSideLeftButton].left

      if (this.$store.state.artwork.leftSideRightButton !== null) {
        right = bjPositions.button[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.leftSideRightButton].right
      }

      let bjButtonPositions = left.concat(right);

      for (
        var i = 0;
        i <
        bjButtonPositions.length;
        i++
      ) {
        var lm = bjButtonPositions[i];
        
        var iconSizeLabel = 
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.content[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize
          ];
        
        var o = {
          id: i,
          top: lm.y,
          left: lm.x,
          height:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].height,
          width:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].width,
          fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.fontSize],
          iconSize: (this.isBigIcon(this.$store.state.artwork.content[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.content[i])
            ? bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel]["P7"]
            : bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.content[i]?.hasTextL2
            ? bjPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : bjPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: bjPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.layout
              ][this.$store.state.artwork.layoutStyle][i],
          },
          content: this.$store.state.artwork.content[i],
        };
        layoutList.push(o);
        this.$store.commit("setAlignment", {
          alignment: this.getAlignment(o),
          index: i,
        });
      }
      
      return layoutList;
    },
    rightLayer4: function () {
      var textSizeLabel = this.$store.state.textSizeMap[this.$store.state.artwork.fontSize];
      var alignment = {};
      if (
        typeof bjPositions.alignment[
        this.$store.state.artwork.rightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          bjPositions.alignment[this.$store.state.artwork.rightLayoutStyle][
          this.$store.state.artwork.rightAlignment
          ];
      }
      var layoutList = [];
      let right = [];

      let left = bjPositions.rightButton[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.rightSideLeftButton].left

      if (this.$store.state.artwork.rightSideRightButton !== null) {
        right = bjPositions.rightButton[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.rightSideRightButton].right
      }

      let bjButtonPositions = left.concat(right);

      for (
        var i = 0;
        i < bjButtonPositions.length;
        i++
      ) {
        var lm = bjButtonPositions[i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.rightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.rightIconSize
          ];

        var o = {
          id: i,
          top: lm.y,
          left: lm.x,
          height:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].height,
          width:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].width,
          fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.fontSize],
          iconSize: (this.isBigIcon(this.$store.state.artwork.rightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.rightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.rightContent[i])
            ? bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel]["P7"]
            : bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.rightContent[i]?.hasTextL2
            ? bjPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : bjPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: bjPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.rightLayout
              ][this.$store.state.artwork.rightLayoutStyle][i],
          },
          content: this.$store.state.artwork.rightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setRightAlignment", {
          alignment: this.getAlignment(o, 'rightAlignment'),
          index: i,
        });
      }
      return layoutList;
    },
    tripleRightLayer4: function () {
      var textSizeLabel = this.$store.state.textSizeMap[this.$store.state.artwork.fontSize];
      var alignment = {};
      if (
        typeof bjPositions.alignment[
        this.$store.state.artwork.tripleRightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          bjPositions.alignment[
          this.$store.state.artwork.tripleRightLayoutStyle
          ][this.$store.state.artwork.tripleRightAlignment];
      }
      var layoutList = [];
      let right = [];
      let left = bjPositions.tripleRightButton[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.tripleRightSideLeftButton].left

      if (this.$store.state.artwork.tripleRightSideRightButton !== null) {
        right = bjPositions.tripleRightButton[this.$store.getters.squareOrRectangle][this.$store.state.artwork.format][this.$store.state.artwork.tripleRightSideRightButton].right
      }

      let bjButtonPositions = left.concat(right);

      for (
        var i = 0;
        i < bjButtonPositions.length;
        i++
      ) {
        var lm = bjButtonPositions[i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.tripleRightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.tripleRightIconSize
          ];

        var o = {
          id: i,
          top: lm.y,
          left: lm.x,
          height:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].height,
          width:
            bjPositions.buttonSize[this.$store.state.artwork.buttonFormat].width,
          fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.fontSize],
          iconSize: (this.isBigIcon(this.$store.state.artwork.tripleRightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.tripleRightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(
            this.$store.state.artwork.tripleRightContent[i]
          )
            ? bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel]["P7"]
            : bjPositions[this.$store.getters.metalOrDefault].icon[this.$store.getters.squareOrRectangle][iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.tripleRightContent[i]?.hasTextL2
            ? bjPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : bjPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: bjPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.tripleRightLayout
              ][this.$store.state.artwork.tripleRightLayoutStyle][i],
          },
          content: this.$store.state.artwork.tripleRightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setTripleRightAlignment", {
          alignment: this.getAlignment(o, 'tripleRightAlignment'),
          index: i,
        });
      }
      return layoutList;
    },
  },
};
</script>
